import store from '@/vuex';

//hly-12586/issue-167413【交付-赤子城】人员信息多岗，填单时无法区分岗位
export const customDepartmentName = (departmentName, departmentPath, operate) => {
  let result = departmentName;
  const myInfo = store.getters.getMyInfo;
  const tenantId = myInfo && myInfo.tenantId;
  const tenantIds = ['1693912054576066561', '1695165198010179585'];
  const departmentPathList = departmentPath.split('|');
  if (tenantIds.indexOf(tenantId) > -1) {
    if (departmentPathList && departmentPathList[0]) {
      result = departmentPathList[0] + (operate || ' | ') + departmentName;
    }
  }
  return result;
};
